export default __webpack_public_path__ + "static/handshake-834a5c9da4db3c83af382e60ef5e0c25.png";